import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function PaintingIcon(props) {
	return (
		<IconBase type="painting" {...props}>
			<path d="M20.4706 20.4706C21.0484 19.8927 21.027 18.9495 20.4235 18.3985L14.4918 12.9826L15.8744 10.2175L15.1673 9.51041L9.51044 15.1673L10.2175 15.8744L12.9826 14.4918L18.3985 20.4235C18.9495 21.027 19.8927 21.0484 20.4706 20.4706ZM19.0563 19.7635C18.526 19.2331 18.154 18.5445 18.3492 18.3492C18.5445 18.154 19.2331 18.526 19.7635 19.0563C19.9587 19.2516 19.9587 19.5682 19.7635 19.7635C19.5682 19.9587 19.2516 19.9587 19.0563 19.7635Z" />
			<path d="M8.44977 14.1066L9.15687 14.8137L14.8137 9.15684L14.1066 8.44974L8.44977 14.1066Z" />
			<path d="M9.15685 3.5L13.753 8.09619L8.09619 13.753L3.5 9.15685L4.91421 7.74264L6.32843 9.15685L5.26777 7.38909L6.32843 6.32843L6.68198 6.68198V5.97487L7.74264 4.91421L8.09619 5.26777V4.56066L9.15685 3.5Z" />
		</IconBase>
	);
}
PaintingIcon.propTypes = iconPropTypes;
